import 'whatwg-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './script/App';
import './scss/style.scss';

if (!Object.entries) {
  Object.entries = function (obj) {
    var ownProps = Object.keys(obj),
      i = ownProps.length,
      resArray = new Array(i); // preallocate the Array
    while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];

    return resArray;
  };
}

(function () {
  if (typeof window.CustomEvent === 'function') return false;

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }
  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent;
})();

Array.prototype.includes ||
  Object.defineProperty(Array.prototype, 'includes', {
    value: function (r, e) {
      if (null == this) throw new TypeError('"this" is null or not defined');
      var t = Object(this),
        n = t.length >>> 0;
      if (0 === n) return !1;
      var i,
        o,
        a = 0 | e,
        u = Math.max(0 <= a ? a : n - Math.abs(a), 0);
      for (; u < n; ) {
        if ((i = t[u]) === (o = r) || ('number' == typeof i && 'number' == typeof o && isNaN(i) && isNaN(o))) return !0;
        u++;
      }
      return !1;
    },
  });

const root = document.getElementById('root');
if (root) {
  ReactDOM.render(<App />, root);
}
